import React, { FC }          from 'react';
import styled                 from 'styled-components';
import { SearchInput }        from '@components/index';
import { ICreditUnion }       from '@typings/accountManagement';
import { AccountSearchTable } from '@modules/accountManagement/components/AccountSearchTable';
import { ISearchInputValues } from '@typings/components';

const Wrapper = styled.div`
  padding: 20px 30px 60px;

  @media (min-width: 1280px) {
    padding: 20px 100px 60px;
  }
`;

interface IProps {
  searchQuery      : string;
  isLoading        : boolean;
  accounts         : ICreditUnion[];
  handleSearchText : (payload: ISearchInputValues) => void;
}

export const AccountSearchPage: FC<IProps> = ({
  isLoading,
  accounts,
  searchQuery,
  handleSearchText,
}) => (
  <Wrapper>
    <SearchInput
      margin       = "10px 0 40px"
      maxWidth     = "800px"
      initialValue = {searchQuery}
      handleSearch = {handleSearchText}
      placeholder  = "Institution name, Contact Person or Account Number"
    />

    <AccountSearchTable
      fetchAccountsStatus = {isLoading}
      accounts            = {accounts}
    />
  </Wrapper>
);
